import { useEffect, useRef } from 'react';

export const useRemountFileInput = (
  open: boolean,
  recordId?: string | null,
  hasExistingFile?: boolean,
  inputId?: string
) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const fileInputKey = `${open ? 'open' : 'closed'}-${recordId || 'new'}-${
    hasExistingFile ? 'has-file' : 'no-file'
  }`;

  const clearFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    if (inputId) {
      const fileInput = document.getElementById(
        inputId
      ) as HTMLInputElement | null;
      if (fileInput) fileInput.value = '';
    }
  };

  useEffect(() => {
    if (open && !hasExistingFile) {
      clearFileInput();
    }
  }, [open, hasExistingFile, recordId]);

  return { fileInputRef, fileInputKey, clearFileInput };
};
